import { UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './RateCard.css';
import { RateTooltip } from '../RateTooltip';

export interface IRateCardProps {
  dataTestId?: string;
  description: string;
  rateMark: React.ReactNode;
  title: string;
}

export const RateCard: React.FC<IRateCardProps> = ({ children, dataTestId, description, rateMark, title }) => {
  return (
    <div className={styles['card']} data-testid={dataTestId}>
      <div className={styles['title']}>
        <UIHeading4>
          {title}
          <span className={styles['info-icon']}>
            <RateTooltip title={title} description={description} />
          </span>
        </UIHeading4>
      </div>

      <div className={styles['rate-info']}>{rateMark}</div>

      {children}
    </div>
  );
};
